/* Saint Texas — lead tracking (7 Oct 2026). When a quote, quick quote, contact or high volume form is sent successfully,
   publish a Shopify customer event "st_lead" { form }. The "Saint Texas leads" custom pixel (saint-texas-worker
   marketing/tracking/shopify-custom-pixel.js, installed in Shopify → Settings → Customer events) turns it into a Meta
   "Lead" and a Google Ads lead conversion. Without that pixel this does nothing visible. Loaded from layout/theme.liquid. */
(function () {
  "use strict";
  var LEADS = { "/api/quick-quote": "quick_quote", "/api/quote-builder": "quote", "/api/contact": "contact", "/api/hv/apply": "high_volume" };
  var real = window.fetch; if (!real) return;
  function publish(form) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish("st_lead", { form: form }); } catch (e) {} }
  window.fetch = function (input, init) {
    var p = real.apply(this, arguments);
    try {
      var u = new URL(typeof input === "string" ? input : input.url, location.href);
      var method = String((init && init.method) || (input && input.method) || "GET").toUpperCase();
      var form = method === "POST" && /(^|\.)sainttexas\.com$/.test(u.hostname) && LEADS[u.pathname];
      var body = init && typeof init.body === "string" ? init.body : "";
      if (form && !/"check"\s*:\s*true/.test(body) && !/"preview"\s*:\s*true/.test(body) && !/"website"\s*:\s*"[^"]/.test(body)) {   /* skip price checks, price-only previews (19 Oct: price first since 17 Oct, every price shown was counting as a Lead) and honeypot (bot) sends */
        p.then(function (r) { if (r && r.ok) r.clone().json().then(function (j) { if (j && j.ok) publish(form); }).catch(function () {}); }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };
})();

/* 22 Oct 2026 (Steve: a hat manufacturing call and email came in that no report counted): taps on any phone number
   (tel:) or email address (mailto:) link publish "st_contact" { type: "call" | "email" }. The custom pixel turns it into
   a Meta "Contact" and the Google Ads "ST Call or Email tap" conversion. Once per type per visit, so repeat taps don't inflate it. */
(function () {
  "use strict";
  var sent = {};
  document.addEventListener("click", function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href^="tel:"], a[href^="mailto:"]');
    if (!a) return;
    var type = /^tel:/i.test(a.getAttribute("href")) ? "call" : "email";
    if (sent[type]) return; sent[type] = 1;
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish("st_contact", { type: type, page: location.pathname }); } catch (x) {}
    try { if (window.clarity) window.clarity("event", type === "call" ? "tap_call" : "tap_email"); } catch (x) {}
  }, true);
})();
